import React from 'react';
import SkullLoader from './ui/SkullLoader';

export default function LoadingSpinner({ size = 'medium' }) {
  return <SkullLoader size={size} />;
}
